import { render, staticRenderFns } from "./ReviewsShow.vue?vue&type=template&id=47f8c39f&scoped=true&lang=pug&"
import script from "./ReviewsShow.vue?vue&type=script&lang=js&"
export * from "./ReviewsShow.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsShow.vue?vue&type=style&index=0&id=47f8c39f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8c39f",
  null
  
)

export default component.exports